import React from 'react';
import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Spinner from '../components/Spinner';
import HighSchoolHome from './HighSchoolHome';
import Landing from './Landing';

const Home: React.FC = () => {
  const { user, isLoading } = useAuth();

  let effectiveUser = user;
  if (!effectiveUser) {
    try {
      const raw = localStorage.getItem('user');
      if (raw) {
        effectiveUser = JSON.parse(raw);
      }
    } catch (e) {
      // ignore parse errors
    }
  }

  if (isLoading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </Box>
    );
  }

  if (effectiveUser) {
    const isHighSchool = 
      effectiveUser.educationLevel === 'high-school' || 
      Boolean(effectiveUser.school || effectiveUser.schoolName || effectiveUser.registrationId || effectiveUser.className);
    if (isHighSchool) {
      return <HighSchoolHome />;
    } else {
      return <Navigate to="/projects" replace />;
    }
  }

  return <Landing />;
};

export default Home;